import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const editPDFPages = ({
                               shumaId,
                               fileID,
                               pages,
                                   }) => dispatch => {
  const data = {
    shumaID: parseInt(shumaId, 10),
    fileID: parseInt(fileID, 10),
    pages: pages.map(page => parseInt(page, 10))
  };

  return axios.post(api.EDIT_PDF_PAGES, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);
    });
};

export const editOrderPDFPages = ({
                               orderID,
                               fileID,
                               pages
                             }) => dispatch => {
  const data = {
    orderID: parseInt(orderID, 10),
    fileID: parseInt(fileID, 10),
    pages: pages.map(page => parseInt(page, 10)),
  };

  return axios.post(api.EDIT_ORDER_PDF_PAGES, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);
    });
};
